// extracted by mini-css-extract-plugin
export default {"container":"styles_container__7UuWM","label":"styles_label__vJm70","textarea":"styles_textarea__1i4WF"};